module.exports = __webpack_public_path__ + "static/img/3ao.33ac1f60.webp";